export default "__VITE_ASSET__DnjpxggS__"